import { ResponseEnum } from "@b2bportal/rbc-activities-api";
import { createAsyncThunk } from "@reduxjs/toolkit";
import type { ActivitiesState } from "../../../../store";
import { fetchActivitiesAvailabilityNextPage } from "./api/fetchActivitiesAvailability";

/**
 * Async thunk for fetching the next page of activities
 */
export const fetchActivitiesNextPage = createAsyncThunk<
  {
    activities: any[];
    nextPageToken: string | null;
    searchId: string;
  },
  { token: string },
  { state: ActivitiesState; rejectValue: { error: string } }
>(
  "activitiesAvailability/fetchActivitiesNextPage",
  async (nextPageToken, thunkAPI) => {
    try {
      const response = await fetchActivitiesAvailabilityNextPage(nextPageToken);

      if (response.Response === ResponseEnum.Failure) {
        return thunkAPI.rejectWithValue({
          error:
            response.errors[0].details ??
            "An error occurred while fetching activities",
        });
      }

      return {
        activities: response.value?.activities,
        nextPageToken: response.value?.nextPageToken?.token ?? null,
        searchId: response.value?.encodedTags ?? "",
      };
    } catch (error) {
      const errorMessage =
        error instanceof Error ? error.message : String(error);
      return thunkAPI.rejectWithValue({ error: errorMessage });
    }
  }
);
